export const Permissions = {
  OtherUsersView: 'OtherUsers.View',
  OtherUsersEdit: 'OtherUsers.Edit',
  ProfileManagementView: 'ProfileManagement.View',
  ProfileManagementEdit: 'ProfileManagement.Edit',
  DocumentTypesView: 'DocumentTypes.View',
  DocumentTypesEdit: 'DocumentTypes.Edit',
  AreaTreeView: 'AreaTree.View',
  AreaTreeEdit: 'AreaTree.Edit',
  DocumentManagementView: 'DocumentManagement.View',
  DocumentManagementEdit: 'DocumentManagement.Edit',
  DocumentManagementDelete: 'DocumentManagement.Delete',
  SettingsView: 'Settings.View',
  SettingsEdit: 'Settings.Edit',
  AuditLogsView: 'AuditLogs.View',
} as const
